<div class="relative group w-[300px] h-[160px] shrink-0">
  <!-- Glow exterior suave -->
  <div
    class="hidden 2xl:block absolute -inset-4 bg-card-amber-glow/20 blur-[28px] rounded-full opacity-35 group-hover:opacity-75 transition-opacity duration-500 z-0 pointer-events-none"
  ></div>

  <ui-card
    variant="contained"
    color="default"
    rounded="xl"
    padding="none"
    [border]="false"
    minHeight="160px"
    minWidth="300px"
    custom-classes="block relative w-full h-full overflow-hidden backdrop-blur-xl bg-gradient-to-br from-card-amber-from/85 via-card-amber-via/82 to-card-amber-to/85 border border-card-amber-border/45 shadow-card-amber hover:shadow-card-amber-hover hover:-translate-y-0.5 transition-all duration-300 group z-10"
  >
    <!-- Glow interno suave -->
    <div
      class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[220px] h-[140px] bg-[radial-gradient(circle,rgba(249,160,27,0.38),transparent_70%)] blur-[70px] opacity-80 pointer-events-none z-0"
    ></div>

    <!-- Línea decorativa -->
    <div class="absolute top-4 right-6 opacity-30 z-0">
      <svg
        viewBox="0 0 200 60"
        class="w-40 h-12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 42 L55 18 L85 38 L125 12 L165 35 L190 28"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <!-- Icono -->
    <div class="absolute top-5 left-5 z-10">
      <img
        src="assets/images/icons/Vector (14).png"
        alt="Estrella"
        class="w-6 h-6 drop-shadow-[0_2px_6px_rgba(249,160,27,0.4)]"
      />
    </div>

    <!-- Nombre app -->
    <div class="absolute top-12 left-5 z-10">
      <h3
        class="text-[10px] font-normal text-orange-300/90 mb-2 truncate max-w-[200px]"
      >
        {{ currentApp?.appName || "Cargando..." }}
      </h3>
    </div>

    <!-- Botones invisibles -->
    <button
      type="button"
      class="absolute inset-y-0 left-0 w-1/2 z-50 cursor-pointer border-0 bg-transparent p-0"
      (click)="prevApp()"
      aria-label="Aplicación anterior"
    >
      <span class="sr-only">Anterior</span>
    </button>

    <button
      type="button"
      class="absolute inset-y-0 right-0 w-1/2 z-50 cursor-pointer border-0 bg-transparent p-0"
      (click)="nextApp()"
      aria-label="Siguiente aplicación"
    >
      <span class="sr-only">Siguiente</span>
    </button>

    <!-- Contenido -->
    <div class="absolute top-[70px] left-5 right-5 z-10 pointer-events-none">
      <p class="text-[20px] font-bold text-white leading-tight">
        {{ currentApp?.AverageActiveUsers || 0 }} usuarios activos
      </p>

      <div class="flex items-center gap-1.5 mt-1">
        <span class="text-[14px] font-bold text-emerald-400">+5%</span>
        <span class="text-[12px] text-gray-300"> Últimos 30 días </span>
      </div>
    </div>

    <!-- Indicadores -->
    <div
      class="absolute bottom-4 left-1/2 -translate-x-1/2 flex items-center gap-1.5 z-[60]"
    >
      @for (_ of carouselIndicators; track $index) {
        <button
          type="button"
          class="h-1.5 rounded-full transition-all duration-300 cursor-pointer border-0 p-0"
          [ngClass]="{
            'w-6 bg-gradient-to-r from-orange-500 to-orange-600':
              $index === currentIndicatorIndex,
            'w-1.5 bg-white/40 hover:bg-orange-400/40':
              $index !== currentIndicatorIndex,
          }"
          (click)="changeCarouselIndex($index); $event.stopPropagation()"
          [attr.aria-label]="'Ir a aplicación ' + ($index + 1)"
        >
          <span class="sr-only">Indicador {{ $index + 1 }}</span>
        </button>
      }
    </div>
  </ui-card>
</div>
